import React from 'react';
import './blogCard.css'
import {Col, Image} from "react-bootstrap";
import {Link} from "react-router-dom";
import CustomButton from "../customBtn/CustomButton";
import useHandleRequest from "../../../custom_hooks/useHandleRequest";


function BlogCard({time,category, to, title, description,image}) {

    const {handleRequestAndNavigate} = useHandleRequest();

    return (
        <Col xl={4} lg={6} md={6} sm={12} className={'px-xxl-5 px-lg-4 py-3'}>
            <div className={'blog-card-wrapper'}>
                <Image src={image}/>
                <div className="card-body">
                    <div className={'header mb-3'}>
                        <div className={'time p-2'}>
                            <span>{time}</span>
                        </div>
                        <Link
                            className={'p-2'}
                            to={to}
                        >{category}</Link>
                    </div>
                    <p className={'title mb-3'}>
                        <Link to={`/blogs/${to}`} >
                            {title}
                        </Link>
                    </p>
                    <p className={'summary'}>
                        {description}
                    </p>
                    <div className={'read-more d-flex align-items-center justify-content-end'}>
                        <Link
                            className={'mb-1 d-inline-block text-decoration-none me-auto'}
                            to={`/blogs/${to}`}
                        >مشاهده بیشتر ...</Link>
                    </div>
                </div>
            </div>
        </Col>
    );
}

export default BlogCard;